import type React from 'react';

interface ThemeCardBaseProps {
  isSelected?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  noCursor?: boolean;
  height?: string;
  minWidth?: string;
  isDisabled?: boolean;
}
export default function ThemeCardBase({
  isSelected = false,
  onClick,
  className = '',
  children,
  height = 'h-full',
  minWidth = '',
  isDisabled = false
}: ThemeCardBaseProps) {
  return (
    <button
      className={`${isDisabled ? 'opacity-50 cursor-not-allowed' : ''} ${minWidth} ${className} ${isSelected ? 'border-red-500' : 'border-divider'} ${onClick ? '' : 'cursor-default'} ${height} w-full bg-content2 border grid place-items-center rounded-md overflow-hidden transition-colors`}
      onClick={onClick}
      disabled={isDisabled}
    >
      {children}
    </button>
  );
}
